import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

export const TokenCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="email" />
        <TextInput source="userId" label="User Id" />
      </SimpleForm>
    </Create>
  );
};
